/// <reference types="vite/client" />
/**
 * Neon Auth Client Configuration
 *
 * This file configures the Neon Auth client using Better Auth under the hood.
 * Auth data is stored directly in the Neon database (neon_auth schema).
 */

import { createAuthClient } from 'better-auth/react';
// import { createAuthClient } from '@neondatabase/auth';

// Neon Auth URL from environment
const NEON_AUTH_URL = import.meta.env.VITE_NEON_AUTH_URL;

if (!NEON_AUTH_URL) {
    console.warn(
        'Missing Neon Auth configuration. Please add VITE_NEON_AUTH_URL to your .env file.'
    );
}

// Better Auth's inferred React client type is not portable across pnpm's generated paths,
// so keep the exported surface stable for declaration emit while preserving runtime behavior.
export const authClient: any = createAuthClient({
    baseURL: NEON_AUTH_URL || '',
    storage: localStorage
});

// Use 'export *' to ensure all types are available if needed, though we specifically want useAuthenticate
export { useAuthenticate, NeonAuthUIProvider, AuthView } from '@neondatabase/auth/react';
